export default __webpack_public_path__ + "static/media/com-nowness.46400d81.mp4";